/* tslint:disable */
/* eslint-disable */
/**
 * chomestatus API
 * The API for chromestatus.com. chromestatus.com is the official tool used for tracking feature launches in Blink (the browser engine that powers Chrome and many other web browsers). This tool guides feature owners through our launch process and serves as a primary source for developer information that then ripples throughout the web developer ecosystem. More details at: https://github.com/GoogleChrome/chromium-dashboard
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldInfoFromJSON, FieldInfoToJSON, } from './FieldInfo';
/**
 * Check if a given object implements the CreateOriginTrialRequest interface.
 */
export function instanceOfCreateOriginTrialRequest(value) {
    return true;
}
export function CreateOriginTrialRequestFromJSON(json) {
    return CreateOriginTrialRequestFromJSONTyped(json, false);
}
export function CreateOriginTrialRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'announcement_url': json['announcement_url'] == null ? undefined : FieldInfoFromJSON(json['announcement_url']),
        'browser': json['browser'] == null ? undefined : FieldInfoFromJSON(json['browser']),
        'ot_description': json['ot_description'] == null ? undefined : FieldInfoFromJSON(json['ot_description']),
        'display_name': json['display_name'] == null ? undefined : FieldInfoFromJSON(json['display_name']),
        'enterprise_policies': json['enterprise_policies'] == null ? undefined : FieldInfoFromJSON(json['enterprise_policies']),
        'finch_url': json['finch_url'] == null ? undefined : FieldInfoFromJSON(json['finch_url']),
        'experiment_goals': json['experiment_goals'] == null ? undefined : FieldInfoFromJSON(json['experiment_goals']),
        'experiment_risks': json['experiment_risks'] == null ? undefined : FieldInfoFromJSON(json['experiment_risks']),
        'experiment_extension_reason': json['experiment_extension_reason'] == null ? undefined : FieldInfoFromJSON(json['experiment_extension_reason']),
        'intent_thread_url': json['intent_thread_url'] == null ? undefined : FieldInfoFromJSON(json['intent_thread_url']),
        'origin_trial_feedback_url': json['origin_trial_feedback_url'] == null ? undefined : FieldInfoFromJSON(json['origin_trial_feedback_url']),
        'origin_trial_id': json['origin_trial_id'] == null ? undefined : FieldInfoFromJSON(json['origin_trial_id']),
        'ot_approval_buganizer_component': json['ot_approval_buganizer_component'] == null ? undefined : FieldInfoFromJSON(json['ot_approval_buganizer_component']),
        'ot_approval_buganizer_custom_field_id': json['ot_approval_buganizer_custom_field_id'] == null ? undefined : FieldInfoFromJSON(json['ot_approval_buganizer_custom_field_id']),
        'ot_approval_criteria_url': json['ot_approval_criteria_url'] == null ? undefined : FieldInfoFromJSON(json['ot_approval_criteria_url']),
        'ot_approval_group_email': json['ot_approval_group_email'] == null ? undefined : FieldInfoFromJSON(json['ot_approval_group_email']),
        'ot_chromium_trial_name': json['ot_chromium_trial_name'] == null ? undefined : FieldInfoFromJSON(json['ot_chromium_trial_name']),
        'ot_display_name': json['ot_display_name'] == null ? undefined : FieldInfoFromJSON(json['ot_display_name']),
        'ot_action_requested': json['ot_action_requested'] == null ? undefined : FieldInfoFromJSON(json['ot_action_requested']),
        'ot_creation__bypass_file_checks': json['ot_creation__bypass_file_checks'] == null ? undefined : FieldInfoFromJSON(json['ot_creation__bypass_file_checks']),
        'ot_documentation_url': json['ot_documentation_url'] == null ? undefined : FieldInfoFromJSON(json['ot_documentation_url']),
        'ot_emails': json['ot_emails'] == null ? undefined : FieldInfoFromJSON(json['ot_emails']),
        'ot_feedback_submission_url': json['ot_feedback_submission_url'] == null ? undefined : FieldInfoFromJSON(json['ot_feedback_submission_url']),
        'ot_has_third_party_support': json['ot_has_third_party_support'] == null ? undefined : FieldInfoFromJSON(json['ot_has_third_party_support']),
        'ot_is_critical_trial': json['ot_is_critical_trial'] == null ? undefined : FieldInfoFromJSON(json['ot_is_critical_trial']),
        'ot_is_deprecation_trial': json['ot_is_deprecation_trial'] == null ? undefined : FieldInfoFromJSON(json['ot_is_deprecation_trial']),
        'ot_owner_email': json['ot_owner_email'] == null ? undefined : FieldInfoFromJSON(json['ot_owner_email']),
        'ot_request_note': json['ot_request_note'] == null ? undefined : FieldInfoFromJSON(json['ot_request_note']),
        'ot_require_approvals': json['ot_require_approvals'] == null ? undefined : FieldInfoFromJSON(json['ot_require_approvals']),
        'ot_stage_id': json['ot_stage_id'] == null ? undefined : FieldInfoFromJSON(json['ot_stage_id']),
        'ot_webfeature_use_counter': json['ot_webfeature_use_counter'] == null ? undefined : FieldInfoFromJSON(json['ot_webfeature_use_counter']),
        'rollout_impact': json['rollout_impact'] == null ? undefined : FieldInfoFromJSON(json['rollout_impact']),
        'rollout_milestone': json['rollout_milestone'] == null ? undefined : FieldInfoFromJSON(json['rollout_milestone']),
        'rollout_platforms': json['rollout_platforms'] == null ? undefined : FieldInfoFromJSON(json['rollout_platforms']),
        'rollout_details': json['rollout_details'] == null ? undefined : FieldInfoFromJSON(json['rollout_details']),
        'desktop_first': json['desktop_first'] == null ? undefined : FieldInfoFromJSON(json['desktop_first']),
        'desktop_last': json['desktop_last'] == null ? undefined : FieldInfoFromJSON(json['desktop_last']),
        'android_first': json['android_first'] == null ? undefined : FieldInfoFromJSON(json['android_first']),
        'android_last': json['android_last'] == null ? undefined : FieldInfoFromJSON(json['android_last']),
        'ios_first': json['ios_first'] == null ? undefined : FieldInfoFromJSON(json['ios_first']),
        'ios_last': json['ios_last'] == null ? undefined : FieldInfoFromJSON(json['ios_last']),
        'webview_first': json['webview_first'] == null ? undefined : FieldInfoFromJSON(json['webview_first']),
        'webview_last': json['webview_last'] == null ? undefined : FieldInfoFromJSON(json['webview_last']),
    };
}
export function CreateOriginTrialRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'announcement_url': FieldInfoToJSON(value['announcement_url']),
        'browser': FieldInfoToJSON(value['browser']),
        'ot_description': FieldInfoToJSON(value['ot_description']),
        'display_name': FieldInfoToJSON(value['display_name']),
        'enterprise_policies': FieldInfoToJSON(value['enterprise_policies']),
        'finch_url': FieldInfoToJSON(value['finch_url']),
        'experiment_goals': FieldInfoToJSON(value['experiment_goals']),
        'experiment_risks': FieldInfoToJSON(value['experiment_risks']),
        'experiment_extension_reason': FieldInfoToJSON(value['experiment_extension_reason']),
        'intent_thread_url': FieldInfoToJSON(value['intent_thread_url']),
        'origin_trial_feedback_url': FieldInfoToJSON(value['origin_trial_feedback_url']),
        'origin_trial_id': FieldInfoToJSON(value['origin_trial_id']),
        'ot_approval_buganizer_component': FieldInfoToJSON(value['ot_approval_buganizer_component']),
        'ot_approval_buganizer_custom_field_id': FieldInfoToJSON(value['ot_approval_buganizer_custom_field_id']),
        'ot_approval_criteria_url': FieldInfoToJSON(value['ot_approval_criteria_url']),
        'ot_approval_group_email': FieldInfoToJSON(value['ot_approval_group_email']),
        'ot_chromium_trial_name': FieldInfoToJSON(value['ot_chromium_trial_name']),
        'ot_display_name': FieldInfoToJSON(value['ot_display_name']),
        'ot_action_requested': FieldInfoToJSON(value['ot_action_requested']),
        'ot_creation__bypass_file_checks': FieldInfoToJSON(value['ot_creation__bypass_file_checks']),
        'ot_documentation_url': FieldInfoToJSON(value['ot_documentation_url']),
        'ot_emails': FieldInfoToJSON(value['ot_emails']),
        'ot_feedback_submission_url': FieldInfoToJSON(value['ot_feedback_submission_url']),
        'ot_has_third_party_support': FieldInfoToJSON(value['ot_has_third_party_support']),
        'ot_is_critical_trial': FieldInfoToJSON(value['ot_is_critical_trial']),
        'ot_is_deprecation_trial': FieldInfoToJSON(value['ot_is_deprecation_trial']),
        'ot_owner_email': FieldInfoToJSON(value['ot_owner_email']),
        'ot_request_note': FieldInfoToJSON(value['ot_request_note']),
        'ot_require_approvals': FieldInfoToJSON(value['ot_require_approvals']),
        'ot_stage_id': FieldInfoToJSON(value['ot_stage_id']),
        'ot_webfeature_use_counter': FieldInfoToJSON(value['ot_webfeature_use_counter']),
        'rollout_impact': FieldInfoToJSON(value['rollout_impact']),
        'rollout_milestone': FieldInfoToJSON(value['rollout_milestone']),
        'rollout_platforms': FieldInfoToJSON(value['rollout_platforms']),
        'rollout_details': FieldInfoToJSON(value['rollout_details']),
        'desktop_first': FieldInfoToJSON(value['desktop_first']),
        'desktop_last': FieldInfoToJSON(value['desktop_last']),
        'android_first': FieldInfoToJSON(value['android_first']),
        'android_last': FieldInfoToJSON(value['android_last']),
        'ios_first': FieldInfoToJSON(value['ios_first']),
        'ios_last': FieldInfoToJSON(value['ios_last']),
        'webview_first': FieldInfoToJSON(value['webview_first']),
        'webview_last': FieldInfoToJSON(value['webview_last']),
    };
}
